var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.urlLinks.topTen.length > 0)?_c('DoughnutChart',{attrs:{"title":"Total Clicks","data":_vm.data,"labels":_vm.labels,"colors":_vm.colors,"options":_vm.options}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }